
import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import PrivacyPolicy from "./components/PrivacyPolicy";
import CreatorsLanding from "./pages/CreatorsLanding";
import Home from "./pages/Home";
import ScrollToTop from "./components/ScrollToTop";
import MetaTagsUpdater from "./components/MetaTagsUpdater"; // Import the new component
import { EventPage } from "./components/EventPage";

function App() {
  return (
    <Router>
      {/* Add ScrollToTop and MetaTagsUpdater just inside the Router */}
      <ScrollToTop />
      <MetaTagsUpdater />
      <Routes>
     <Route path="/" element={<CreatorsLanding />} />

     
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/client" element={<Home />} />
        <Route path="/event/*" element={<EventPage />} />
      </Routes>
    </Router>
  );
}

export default App;
